import React,{useEffect} from 'react';
import Header from '../../components/Header';
import StudentLoginMain from './StudentLoginMain';
import Footer from '../../components/Footer';


const StudentLogin = () => {
        useEffect(() => {
        document.title = "Student Membership Login | Society of Aquaculture Professionals";
      }, []);
  return (
    <>
      <Header/>

      <StudentLoginMain />

      <Footer/>
    </>
  );
};

export default StudentLogin;
